import type { LegalDocumentSection } from '@/components/legal/LegalDocumentPage';
import type { LegalLocale } from './resolveLegalLocale';

/**
 * Table-of-contents entries for each legal document locale. The ids must
 * match the anchors `slugifyHeading` derives from that locale's markdown
 * headings — enforced by `__tests__/legalDocumentSections.test.ts`.
 */
export const TERMS_SECTIONS: Record<LegalLocale, LegalDocumentSection[]> = {
  pt: [
    { id: '1-definicoes', title: '1. Definições' },
    { id: '2-aceitacao-do-termos', title: '2. Aceitação dos Termos' },
    { id: '3-quem-somos-e-o-que-fazemos', title: '3. Quem Somos e o que Fazemos' },
    { id: '4-condicoes-gerais-de-uso', title: '4. Condições Gerais de Uso' },
    { id: '5-do-cadastro', title: '5. Do Cadastro' },
    { id: '6-uso-da-plataforma', title: '6. Uso da Plataforma' },
    { id: '7-sobre-o-suporte-tecnico', title: '7. Sobre o Suporte Técnico' },
    { id: '8-metodos-de-pagamento', title: '8. Métodos de Pagamento' },
    { id: '9-disposicoes-gerais', title: '9. Disposições Gerais' },
  ],
  en: [
    { id: '1-definitions', title: '1. Definitions' },
    { id: '2-acceptance-of-the-terms', title: '2. Acceptance of the Terms' },
    { id: '3-who-we-are-and-what-we-do', title: '3. Who We Are and What We Do' },
    { id: '4-general-terms-of-use', title: '4. General Terms of Use' },
    { id: '5-registration', title: '5. Registration' },
    { id: '6-use-of-the-platform', title: '6. Use of the Platform' },
    { id: '7-technical-support', title: '7. Technical Support' },
    { id: '8-payment-methods', title: '8. Payment Methods' },
    { id: '9-general-provisions', title: '9. General Provisions' },
  ],
};

export const PRIVACY_SECTIONS: Record<LegalLocale, LegalDocumentSection[]> = {
  pt: [
    { id: '1-definicoes', title: '1. Definições' },
    { id: '2-das-politicas-de-privacidade', title: '2. Das Políticas de Privacidade' },
    { id: '3-contas-de-redes-sociais-conectadas', title: '3. Contas de Redes Sociais Conectadas' },
    { id: '4-disposicoes-gerais', title: '4. Disposições Gerais' },
  ],
  en: [
    { id: '1-definitions', title: '1. Definitions' },
    { id: '2-privacy-policies', title: '2. Privacy Policies' },
    { id: '3-connected-social-accounts', title: '3. Connected Social Accounts' },
    { id: '4-general-provisions', title: '4. General Provisions' },
  ],
};
